class AdpIconButtonController {
  constructor() {
    this.name = 'adpIconButton';
  }
}

export default AdpIconButtonController;



// WEBPACK FOOTER //
// ./src/app/components/adpIconButton/adpIconButton.controller.js